import { cn } from '@/lib/utils';

interface TypographyProps {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'blockquote' | 'muted';
  className?: string;
  children: React.ReactNode;
}

export function Typography({ variant = 'p', className, children, ...props }: TypographyProps) {
  const Comp =
    variant === 'blockquote'
      ? 'blockquote'
      : variant === 'muted'
      ? 'p'
      : variant === 'p'
      ? 'p'
      : variant;

  return (
    <Comp
      className={cn(
        {
          'scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl': variant === 'h1',
          'scroll-m-20 text-3xl font-semibold tracking-tight': variant === 'h2',
          'scroll-m-20 text-2xl font-semibold tracking-tight': variant === 'h3',
          'scroll-m-20 text-xl font-semibold tracking-tight': variant === 'h4',
          'leading-7': variant === 'p',
          'mt-6 border-l-2 border-primary pl-6 italic': variant === 'blockquote',
          'text-sm text-muted-foreground': variant === 'muted',
        },
        className,
      )}
      {...props}>
      {children}
    </Comp>
  );
}
